import {Injectable} from '@angular/core';
import {UsersService} from '../api/services/users.service';
import {FirewallService as ApiFirewallService} from '../api/services/firewall.service';
import {FirewallModel} from '../api/models/firewall-model';

@Injectable()
export class FirewallService {

  constructor(private apiUserService: UsersService,
              private apiFirewallService: ApiFirewallService) {

  }

  public async getFirewallIpAddressById(id: string): Promise<FirewallModel> {
    return await this.apiFirewallService.firewallGetIpAddressById({id: id}).toPromise();
  }

  public async getFirewallLimits(): Promise<number> {
    return await this.apiFirewallService.firewallGetFirewallLimits().toPromise();
  }

  public async saveIpAddress(model: FirewallModel): Promise<boolean> {
    await this.apiFirewallService.firewallSaveIpAddress({body: model}).toPromise();

    return true;
  }

  public async requestExtendLimits(model: FirewallModel): Promise<boolean> {
    await this.apiFirewallService.firewallRequestExtendLimits({body: model}).toPromise();

    return true;
  }

  public async deleteIpAddress(id: string): Promise<boolean> {
    await this.apiFirewallService.firewallDeleteIpAddressById({id: id}).toPromise();

    return true;
  }

  public async getClientIpAddress(): Promise<string> {
    return await this.apiFirewallService.firewallGetClientIpAddress().toPromise();
  }
}
